module.exports = __webpack_public_path__ + "img/product19-zixun.b5ed1e70.svg";